import { Outlet } from "react-router-dom";

import { TelaComAbas } from "@/shared/components/tela-com-abas";
import type { ControlPanelViewModel } from "./types-control-panel";

/** Casca do Painel (Figma 4135:138674): título, abas Usuários, Perfis, Permissões e Auditoria e a aba da rota. */
export function ControlPanelView({ titulo, abas, abasLabel, mobileQuery }: ControlPanelViewModel) {
  return (
    <TelaComAbas
      titulo={titulo}
      abas={abas}
      abasLabel={abasLabel}
      mobileQuery={mobileQuery}
      testId="control-panel-screen"
      headerTestId="control-panel-header"
      variante="janela"
    >
      <Outlet />
    </TelaComAbas>
  );
}
